import React from 'react';
import clsx from 'clsx';

import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import API from '../../services/api';
import Balance from './balance';
import CustomAlert from '../custom/alert';
import Data from './data';
import Logs from '../logs-cli';
import Account from './account';
import Comparativo from './Comparativo';
import useStyles from './styles';

export default function ComponentClient() {
  const account_id = Number(API.encryptedSessionStorage.getItem('account_id', API.encryptedSessionStorage.getTokenData().uid));

  const classes = useStyles();
  const [alert, setAlert] = React.useState({ open: false, message: '' });
  const load = React.useRef(true);

  const [state, setState] = React.useState({});

  function componentDidMount() {
    if (load.current) {
      API.Accounts.show(account_id).then(onSuccess).catch(onFailure);
    }
    return function componentWillUnmount() {
      load.current = false;
    };
  }

  React.useEffect(componentDidMount, []);

  function onSuccess(response) {
    if (load.current && response.data) {
      setState(response.data);
    }
  }

  function onFailure(error) {
    if (load.current && error) {
      setAlert({ open: true, message: error.message });
    }
  }

  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  const chartHeightPaper = clsx(classes.paper, classes.chartHeight);

  return (
    <Container maxWidth="lg" className={classes.container}>
      <CustomAlert open={alert.open} onClose={() => setAlert({ ...alert, open: false })}>
        {alert.message}
      </CustomAlert>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6} lg={7}>
          <Paper className={fixedHeightPaper}>
            <Data state={state} />
          </Paper>
        </Grid>

        <Grid item xs={12} md={4} lg={5}>
          <Paper className={fixedHeightPaper}>
            <Account state={state} />
          </Paper>
        </Grid>

        <Grid item xs={12} md={8} lg={4}>
          <Paper className={chartHeightPaper}>
            <Comparativo state={state} />
          </Paper>
        </Grid>

        <Grid item xs={12} md={8} lg={8}>
          <Paper className={chartHeightPaper}>
            <Balance />
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Logs></Logs>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}
